import useCalendarContext from './CalendarContext';
import {getFullWeekMonthDates} from 'utils/calendar';
import { Moment } from 'moment';
import DayCell from './CalendarContent/DayCell';

type CalendarContentPureProps = {
  monthDates: Moment[][];
};

const CalendarContentPure = ({
  monthDates,
}: CalendarContentPureProps): JSX.Element => {
  const content = monthDates.map((week, weekIndex) => (
    <tr key={weekIndex}>
      {week.map((day, index) => (
        <DayCell date={day} key={index} />
      ))}
    </tr>
  ));

  return <>{content}</>;
};

const CalendarContent = (): JSX.Element => {
  const { currentDate } = useCalendarContext();
  const monthDates = getFullWeekMonthDates(currentDate);

  return <CalendarContentPure monthDates={monthDates} />;
};

export default CalendarContent;
